const FooterData = [
    {
        title: "For Users",
        submenu: [
            {
                title: "Register/ Update your profile",
                link: "/loginDataUser"
            },
            {
                anchorTitle: "How to Discover/ Support NPOs",
                anchor: "discover_sec"
            },
            {
                anchorTitle: "Certified NPOs List",
                anchor: "seal_sec"
            },
            {
                anchorTitle: "Get involved with NPOs",
                anchor: "repositories_sec"
            },
            {
                title: "Announce your Offers/ Events/ Campaigns for NPOs",
                link: "/"
            },
            {
                anchorTitle: "Power your philanthropy & impact",
                anchor: "philanthropy_sec"
            },
            {
                title: "Research Reports & Insights",
                link: "/"
            },
            // {
            //     title: "Invite/ Share",
            //     link: "/page/contact-classic"
            // },
        ]
    },
    {
        title: "For NPOs",
        submenu: [
            {
                title: "Register/ Update your NPO profile",
                link: "/npo-login"
            },
            {
                title: "Apply for Certification",
                link: "/"
            },
            {
                title: "How to Enhance Credibility of your NPO",
                link: "/"
            },
            {
                anchorTitle: "Offers/ Asks/ Events/ Announcements",
                anchor: "opportunities"
            },
            {
                title: "Access Resources for NPOs",
                link: "https://resources.guidestarindia.org"
            },
            {
                title: "Join our Changemakers Forum",
                link: "https://forum.guidestarindia.org/"
            },
            {
                title: "Calendar of Events, Opportunities and Important dates",
                link: "/"
            },
        ]
    },
    {
        title: "About Us",
        submenu: [
            {
                title: "Theory of Change and Impact",
                link: "/"
            },
            {
                title: "People, Partners and Supporters",
                link: "/"
            },
            {
                title: "Statutory and FCRA Compliance",
                link: "/"
            },
            {
                head:'Other Links'
            },
            {
                title: "Advanced Search",
                link: "/search"
            },
            {
                title: "Help/ FAQs",
                link: "/"
            },
            {
                title: "Media",
                link: "/"
            },
            {
                title: "Contact Us",
                link: "/contact"
            },
        ]
    },
    
]

const FooterUnderData = [
    { text: "PRIVACY POLICY", path: "/privacy-policy" },
    { text: "TERMS OF USE", path: "/terms-of-use" },
    { text: "DISCLAIMER", path: "/disclaimer" },
    { text: "COPYRIGHT CSIS INDIA", path: "/copyright" },
    { text: "WORK WITH US", path: "/careers" },
    { text: "CONTACT US", path: "/contact" },
    { text: "SEND FEEDBACK", path: "/feedback" },
    { text: "REPORT AN NPO/ NGO/ CONCERNS", path: "/report-npo" },
    { text: "SUPPORT GUIDESTAR INDIA", path: "/support" }
];

export { FooterData, FooterUnderData }